/* ASSETS  */
import boutonLire from "assets/img/bouton_lire.png";
import boutonLireHoover from "assets/img/bouton_lire_hoover.png";
import boutonRegarder from "assets/img/bouton_regarder.png";
import boutonRegarderHoover from "assets/img/bouton_regarder_hoover.png";
import boutonCoeur from "assets/img/bouton_coeur.png";
import boutonCoeurHoover from "assets/img/bouton_coeur_hoover.png";
import homeIconBlack from "assets/img/home-icon-black.png";

import blockBlancFakeChoiceSmall from "assets/img/bloc_blanc_fakechoice_small.png";
import blockBlancFakeChoiceMedium from "assets/img/bloc_blanc_fakechoice_medium.png";

/* FOREGROUND */
import epilogue_silhouette from "assets/img/journey/sifa/silhouette_epilogue.png";

/* BACKGROUND */
import baseBackgroundImg from "assets/img/home-background-min.jpg";
import backgroundChoice from "assets/img/journey/sifa/silhouette_choice.png";
import backgoundPurple from "assets/img/backgound_purple.jpg";
import sifaBG1 from "assets/img/journey/sifa/01_MINE_01-min.jpg";
import sifaBG2 from "assets/img/journey/sifa/02_MINE_02-min.jpg";
import sifaBG3 from "assets/img/journey/sifa/03_MINE_03-min.jpg";
import sifaBG4 from "assets/img/journey/sifa/04_COLLINES-min.jpg";
import sifaBG5 from "assets/img/journey/sifa/05_PETITE_VILLE-min.jpg";
import sifaBG6 from "assets/img/journey/sifa/06_PIEDS_MILITAIRES-min.jpg";
import sifaBG7 from "assets/img/journey/sifa/07_BUKAVU-min.jpg";
import sifaBG8 from "assets/img/journey/sifa/08_COUSINS-min.jpg";
import sifaBG9 from "assets/img/journey/sifa/09_BUKAVU_02-min.jpg";
import sifaBG10 from "assets/img/journey/sifa/10_MAMAN-min.jpg";
import sifaBG11 from "assets/img/journey/sifa/11_CAMP_OUGANDA_01-min.jpg";
import sifaBG12 from "assets/img/journey/sifa/12_CAMP_OUGANDA_02-min.jpg";
import sifaBG13 from "assets/img/journey/sifa/13_CAMP_OUGANDA_03-min.jpg";
import sifaBG14 from "assets/img/journey/sifa/14_REINSTALLATION-min.jpg";
import sifaBG15 from "assets/img/journey/sifa/15_2B6KT35_retouche-min.jpg";
import sifaBG16 from "assets/img/journey/sifa/16_FB39NA-min.jpg";

/* MAPS */
import mapBukavu from "assets/img/journey/sifa/NL_parcours_2_carte_1.png";
import mapKampala from "assets/img/journey/sifa/NL_parcours_2_carte_2.png";

/* SOUNDS */
import soundIntro from "assets/sounds/sifa_nl/SIFA_NL_INTRO.mp3";
import SIFA_FR_SEQ01 from "assets/sounds/sifa_nl/SIFA_NL_SEQ01.mp3";
import SIFA_FR_SEQ02 from "assets/sounds/sifa_nl/SIFA_NL_SEQ02.mp3";
import SIFA_FR_SEQ03 from "assets/sounds/sifa_nl/SIFA_NL_SEQ03.mp3";
import SIFA_FR_SEQ04 from "assets/sounds/sifa_nl/SIFA_NL_SEQ04.mp3";
import SIFA_FR_SEQ05 from "assets/sounds/sifa_nl/SIFA_NL_SEQ05.mp3";
import SIFA_FR_SEQ06 from "assets/sounds/sifa_nl/SIFA_NL_SEQ06.mp3";
import SIFA_FR_SEQ07 from "assets/sounds/sifa_nl/SIFA_NL_SEQ07.mp3";
import SIFA_FR_SEQ08 from "assets/sounds/sifa_nl/SIFA_NL_SEQ08.mp3";
import SIFA_FR_SEQ09 from "assets/sounds/sifa_nl/SIFA_NL_SEQ09.mp3";
import SIFA_FR_SEQ10 from "assets/sounds/sifa_nl/SIFA_NL_SEQ10.mp3";
import SIFA_FR_SEQ11 from "assets/sounds/sifa_nl/SIFA_NL_SEQ11.mp3";
import SIFA_FR_SEQ12 from "assets/sounds/sifa_nl/SIFA_NL_SEQ12.mp3";
import SIFA_FR_SEQ13 from "assets/sounds/sifa_nl/SIFA_NL_SEQ13.mp3";
import SIFA_FR_SEQ14 from "assets/sounds/sifa_nl/SIFA_NL_SEQ14.mp3";
import SIFA_FR_SEQ15 from "assets/sounds/sifa_nl/SIFA_NL_SEQ15.mp3";
import SIFA_FR_SEQ16 from "assets/sounds/sifa_nl/SIFA_NL_SEQ16.mp3";
import SIFA_FR_EPILOGUE1 from "assets/sounds/sifa_nl/SIFA_NL_EPILOG01.mp3";
import SIFA_FR_EPILOGUEBukavu from "assets/sounds/sifa_nl/SIFA_NL_EPILOG02.mp3";
import SIFA_FR_EPILOGUEKamaplaSolo from "assets/sounds/sifa_nl/SIFA_NL_EPILOG03.mp3";
import SIFA_FR_EPILOGUEKamaplaGroupe from "assets/sounds/sifa_nl/SIFA_NL_EPILOG04.mp3";
import SIFA_FR_EPILOGUEFIN1 from "assets/sounds/sifa_nl/SIFA_NL_EPILOGFIN01.mp3";
import SIFA_FR_EPILOGUEFIN2 from "assets/sounds/sifa_nl/SIFA_NL_EPILOGFIN02.mp3";
import SIFA_FR_EPILOGUEFIN3 from "assets/sounds/sifa_nl/SIFA_NL_EPILOGFIN03.mp3";

import PhylactereChezNous from "assets/img/journey/sifa/phylactere_ het_leven_NL.png";
import PhylactereFrere from "assets/img/journey/sifa/phylactere_mijn_broertjes.png";
import { getYoutubeIframe } from "./utils";

const choiceButtonStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: 20,
  padding: "30px!important",
  minHeight: 100,
  maxWidth: 250,
  color: "white",
};

const otherChoiceButtonStyle = {
  ...choiceButtonStyle,
  fontSize: "1.5rem!important",
  fontWeight: "700!important",
  color: "black!important",
  maxWidth: 200,
  backgroundImage: `url(${blockBlancFakeChoiceSmall})!important`,
  "&:hover": { textDecoration: "underline" },
};

const base_choice_style = {
  containerStyle: {
    backgroundColor: "white",
    color: "black",
  },
  fixedImageBackground: backgroundChoice,
  fixedImageBackgroundStyle: {
    backgroundSize: "35% auto",
    backgroundPosition: "95% center",
  },

  homeIcon: homeIconBlack,
  homeHoverIcon: homeIconBlack,

  contentStyle: {
    width: "50%",
    maxWidth: "1150px",
    marginLeft: "10%",
  },
};

const epilogeAnimationTiming = 2500;
const epilogeSoundAdditionalDelay = 1500;
const base_epilogue = {
  type: "epilogue",
  background: { src: backgoundPurple },
  foreground: {
    src: epilogue_silhouette,
    // style: { height: '80vh', position: 'relative', top: '10vh', left: '-18vw', opacity: 1, transition: 'transform linear', transform: 'scale(1)', transformOrigin: '44.46% 71.64%' },
    style: {
      height: "80vh",
      position: "relative",
      top: "10vh",
      left: "-18vw",
      opacity: 0,
      animationFillMode: "forwards",
      animationTimingFunction: "linear",
      transform: "scale(.8)",
      transformOrigin: "44.46% 71.64%",
    },
    animations: [{ delay: 250, style: { animationName: "opacityNoneToFull", animationDuration: `${epilogeAnimationTiming}ms` } }],
  },
};

const colors = {
  violet: "#5A36E4",
};

export const sifa_nl = {
  description: {
    name: "Sifa",
    age: "12",
    city: "Mbau (Zuid-Kivu)",
    country: "DR CONGO",
    text: "Zoals iedereen in het dorp werken ook mijn beide ouders in de mijn. Ik ben al groot en als zij er niet zijn, zorg ik voor mijn twee kleine broertjes. Mijn vader moet graven en mijn moeder vergruist stenen. Ik ben bang van de mijn. Mijn oom is gestorven toen er een paar jaar geleden een instorting was ... Maar zonder het geld van de mijn kunnen we niet leven. Ik vraag me af waarvoor die mineralen dienen en wie ze zo hard nodig heeft.",
    sound: soundIntro,
  },
  additionalLoad: [
    { type: "img", src: backgoundPurple },
    { type: "img", src: epilogue_silhouette },
    { type: "img", src: blockBlancFakeChoiceSmall },
    { type: "img", src: blockBlancFakeChoiceMedium },
    { type: "img", src: PhylactereChezNous },
    { type: "img", src: PhylactereFrere },
    { type: "img", src: boutonLire },
    { type: "img", src: boutonLireHoover },
    { type: "img", src: boutonRegarder },
    { type: "img", src: boutonRegarderHoover },
    { type: "img", src: boutonCoeur },
    { type: "img", src: boutonCoeurHoover },
  ],
  steps: [
    {
      id: "SIFA 01",
      type: "sequence",
      sound: SIFA_FR_SEQ01,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Er is een ongeluk gebeurd in de mijn.", delay: 3110 },
        { type: "text", text: "Mijn vader heeft zijn been gebroken en kan niet meer werken. ", delay: 2950 },
        { type: "text", text: "Mijn ouders zeggen dat iemand van ons vanaf nu moet gaan werken met mijn moeder,", delay: 4070 },
        { type: "text", text: "anders hebben we niet genoeg geld om eten te kopen. ", delay: 4950 },
        { type: "text", text: "Ze vinden dat \u00e9\u00e9n van mijn broers moet gaan. ", delay: 3060 },
        { type: "text", text: "Het klopt, mannen verdienen meer geld dan vrouwen in de mijn\u2026", delay: 2910 },
        { type: "text", text: "Maar mijn broertjes zijn nog zo jong \nen kinderen moeten in de gevaarlijkste schachten werken.", delay: 3990 },
        { type: "text", text: "Ik zou kunnen voorstellen om in zijn plaats te gaan. ", delay: 5960 },
        { type: "text", text: "Maar dan zouden we minder geld verdienen... ", delay: 3140 },
        { type: "text", text: "", delay: 2880 },
        { type: "goToNext", delay: 4050 },
      ],
      background: {
        src: sifaBG1,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "41070ms", animationName: "scale20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info1",
    },
    {
      id: "choice1",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Wat zou jij doen in mijn plaats?<br/>Zou jij aan je ouders voorstellen om <span class="background-underlined very-large">jou in de mijn te laten</span> werken of zou je je <span class="background-underlined large">broertje laten ga</span>an?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Je ouders overtuigen om je in de mijn te laten werken",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "SIFA 02",
        },
        {
          type: "button",
          key: "button-2",
          text: "Je broertje laten gaan",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "SIFA 03",
        },
      ],
    },
    {
      id: "SIFA 02",
      type: "sequence",
      sound: SIFA_FR_SEQ02,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik werk al een paar weken in de mijn. ", delay: 4080 },
        { type: "text", text: "Het werk is nog zwaarder dan ik dacht. ", delay: 2920 },
        { type: "text", text: "Ik sleep met zware zakken steen en soms vergruis ik ze ook. ", delay: 2200 },
        { type: "text", text: "Ik denk veel aan mijn broertje.", delay: 4820 },
        { type: "text", text: "Ik ben opgelucht dat hij niet met de andere kinderen \nin die smalle mijnschachten moet gaan graven. ", delay: 2050 },
        { type: "text", text: "De laatste dagen heb ik gezien dat er iets gaande is rond de mijn\u2026", delay: 5950 },
        { type: "text", text: "Eerst waren er een paar mannen met geweren die keken hoe wij werkten. ", delay: 4990 },
        { type: "text", text: "Maar nu zijn er elke dag meer.", delay: 4100 },
        { type: "text", text: "", delay: 4000 },
        { type: "goToNext", delay: 1100 },
      ],
      background: {
        src: sifaBG2,
        style: {
          "--imageWidth": "140vw",
          "--scale": "calc(6/7)", //6/7
          "--imageHeight": "calc(140vw * 2/3)",
          width: "var(--imageWidth)",
          height: "var(--imageHeight)", //'auto',
          transformOrigin: "top left",
          transform: "scale(var(--scale)) translateX(0) translateY(calc( -1/2*var(--scale)*var(--imageHeight) + 50vh ) )",
          // transition: 'transform linear',
        },
        animations: [{ delay: 50, style: { animationDuration: "36210ms", animationName: "animationSifa2" } }], // transform: 'scale(1) translateX(-40vw) translateY(0)' // translateY(calc( -1/2*var(--imageHeight) + 50vh ) )
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 04",
    },
    {
      id: "SIFA 03",
      type: "sequence",
      sound: SIFA_FR_SEQ03,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik durfde niet voor te stellen om de plaats van mijn broertje in te nemen.", delay: 6040 },
        { type: "text", text: "Ik ben beschaamd. ", delay: 3170 },
        { type: "text", text: "Als ik het huishouden niet moet doen, ga ik bij hem langs, ik neem water mee.", delay: 1910 },
        { type: "text", text: "Ik maak me veel zorgen om hem.", delay: 5030 },
        { type: "text", text: " Hij moet in de smalle schachten waar je maar moeilijk kunt ademen.", delay: 1980 },
        { type: "text", text: "Hij is een van de kleinste jongens die in de mijn werkt.", delay: 3980 },
        { type: "text", text: "De laatste dagen maak ik me niet alleen zorgen om mijn broertje\u2026", delay: 3100 },
        { type: "text", text: "Er is iets gaande rond de mijn. ", delay: 3840 },
        { type: "text", text: "Eerst waren er een paar mannen met geweren die keken hoe we werkten. ", delay: 2040 },
        { type: "text", text: "Maar nu zijn er elke dag meer.", delay: 4010 },
        { type: "text", text: "", delay: 4130 },
        { type: "goToNext", delay: 1980 },
      ],
      background: {
        src: sifaBG3,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "41210ms", animationName: "scale20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 04",
    },
    {
      id: "SIFA 04",
      type: "sequence",
      sound: SIFA_FR_SEQ04,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Toen ik naar huis ging, zag ik mensen die wegliepen \nen naar me schreeuwden dat ik moest vluchten. ", delay: 7000 },
        { type: "text", text: "Ze werden achternagezeten door mannen met geweren en machetes. ", delay: 5230 },
        { type: "text", text: "Ik dacht niet na, ik verstopte me in het bos. ", delay: 3960 },
        { type: "text", text: "Waar is mijn familie?\nWat is er met hen gebeurd? ", delay: 3880 },
        { type: "text", text: "Als ik hier blijf, kan ik hen nog terugvinden. ", delay: 3040 },
        { type: "text", text: "Maar ik mag me niet laten vangen door de gewapende bende.", delay: 3920 },
        { type: "text", text: "Ik weet wat ze doen: ze verkrachten en moorden.", delay: 3000 },
        { type: "text", text: "Als ik wegloop van het dorp, ben ik veiliger.", delay: 3070 },
        { type: "text", text: "", delay: 4080 },
        { type: "goToNext", delay: 3880 },
      ],
      background: {
        src: sifaBG4,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "41060ms", animationName: "scale20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "info2",
    },
    //5
    {
      id: "choice2",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Ik weet niet wat ik moet doen... Wat zou jij doen?<br/>Zou je in de <span class="background-underlined large">buurt van het dorp</span> blijven om je familie te zoeken of zou je jezelf in <span class="background-underlined large">veiligheid brengen</span> en weglopen?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "In de buurt blijven",
          buttonStyle: choiceButtonStyle,
          action: "fakeChoice",
          actionText:
            "Ik ben na de aanvallen samen met andere dorpelingen een paar dagen in de heuvels gebleven. Die ochtend hoorden we schoten en geschreeuw … De gewapende bende komt dichterbij! Ik weet nog altijd niet wat er met mijn familie is gebeurd, maar ik kan hier niet langer blijven.",
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: "60vh", width: "40vw", maxWidth: "500px" },
        },
        {
          type: "button",
          key: "button-2",
          text: "Wegvluchten uit het dorp",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "SIFA 05",
        },
      ],
    },
    {
      id: "SIFA 05",
      type: "sequence",
      sound: SIFA_FR_SEQ05,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik heb een aardeweg gevolgd en ben in een kleine stad aangekomen. ", delay: 2140 },
        { type: "text", text: "We waren met velen op de vlucht.", delay: 4060 },
        { type: "text", text: "Vrienden uit het dorp hebben me meegenomen. ", delay: 2010 },
        { type: "text", text: "Een paar dagen later hoorden we dat de gewapende bende \nuit de streek was weggetrokken", delay: 2930 },
        { type: "text", text: "  en zijn we allemaal teruggekeerd naar Mbau.", delay: 4940 },
        { type: "text", text: "Ik heb mijn vader en twee broertjes levend teruggevonden.", delay: 2960 },
        { type: "text", text: "Wat een goed nieuws. ", delay: 3080 },
        { type: "text", text: "Maar mijn moeder is er niet ... ", delay: 1890 },
        {
          type: "text",
          text: "Ze hebben me verteld dat ze verkracht is en dat ze samen met mijn tante \nop zoek is gegaan naar een dokter. ",
          delay: 2010,
        },
        { type: "text", text: "Nu ben ik de vrouw in huis en mijn twee broertjes \nzijn weer aan het werk in de mijn. ", delay: 6050 },
        { type: "text", text: "Altijd weer de mijn.", delay: 4970 },
        { type: "text", text: "", delay: 2010 },
        { type: "goToNext", delay: 1170 },
      ],
      background: {
        src: sifaBG5,
        style: { transform: "scale(1.2)", transition: "transform linear" }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "40220ms", animationName: "scaleDown20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 06",
    },
    {
      id: "SIFA 06",
      type: "sequence",
      sound: SIFA_FR_SEQ06,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Eergisteren was er een nieuwe aanval en zijn we weggevlucht. Alweer.", delay: 3120 },
        { type: "text", text: "Gewapende mannen hebben mijn vader te pakken gekregen. ", delay: 4880 },
        { type: "text", text: "Sindsdien hebben we hem niet meer gezien...  ", delay: 3010 },
        { type: "text", text: "Mijn broertjes en ik zitten samen met andere jongeren in de heuvels,", delay: 2190 },
        { type: "text", text: " we hebben honger en dorst. ", delay: 4010 },
        { type: "text", text: "Strijders van een rivaliserende bende zijn bij ons gekomen. ", delay: 2880 },
        { type: "text", text: "Als we ons bij hen voegen, beloven ze dat ze onze familie zullen wreken ", delay: 4010 },
        { type: "text", text: "en ons land zullen teruggeven. ", delay: 4920 },
        { type: "text", text: "Sommige jongeren willen dit doen, \nmaar mijn broertjes en ik twijfelen. ", delay: 1210 },
        { type: "text", text: "Als we instemmen, zal de bende ons beschermen. ", delay: 4800 },
        { type: "text", text: "Ik vertel mijn broertjes dat we familie hebben in Bukavu.", delay: 2210 },
        { type: "text", text: "We zouden kunnen proberen om naar daar te gaan. ", delay: 3900 },
        { type: "text", text: "Maar de stad is erg ver en we lopen veel risico \nals we met z\u2019n drie\u00ebn alleen op pad gaan.", delay: 2950 },
        { type: "text", text: "", delay: 6080 },
        { type: "goToNext", delay: 2060 },
      ],
      background: {
        src: sifaBG6,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "52230ms", animationName: "scale20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "info3",
    },
    {
      id: "choice3",
      type: "choice",

      ...base_choice_style,
      contentText:
        "Wat een <span class='background-underlined large'>moeilijke keuze</span>! Wat zou jij doen in mijn plaats?<br/>Zou jij de gewapende mannen vertrouwen en <span class='background-underlined large'>bij de bende gaan</span>? Of zou je naar Bukavu proberen te gaan, op zoek naar <span class='background-underlined medium'>je familie</span>, ook al is dit een reis met veel risico’s ?",
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Bij de gewapende bende gaan",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title: 'We<span class="background-underlined medium">et je dat zeke</span>r?<br/>Kunnen die mensen ons echt helpen en beschermen?',
            buttons: [
              {
                text: "Ja, ik ben zeker",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "epilogue1",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
        {
          type: "button",
          key: "button-2",
          text: "Naar Bukavu proberen te gaan",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title:
              'We<span class="background-underlined medium">et je dat zeke</span>r?<br/>Het is een lange weg naar Bukavu en ik durf niet te denken aan wat ons kan overkomen als we onderweg aangevallen worden.',
            buttons: [
              {
                text: "Ja, ik ben zeker",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "mapBukavu",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
      ],
    },
    {
      id: "epilogue1",

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUE1,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe mijn leven eruitziet in een gewapende bende",
          text: "We zitten nu al maanden bij de gewapende bende. Het is niet wat ik had verwacht, ik denk dat de angst ervoor heeft gezorgd dat we een grote fout hebben gemaakt. Ik wilde graag terugkeren naar Mbau, weer naar mijn huis, zoals ze ons hadden beloofd, maar dat was een leugen. We moeten mensen doden, dorpen plunderen en andere kinderen rekruteren. Wat maakt onze bende dan anders dan de andere? We krijgen alcohol, dat is ons salaris, zeggen ze. Door te drinken probeer ik alles te vergeten. Ik wil hier weg, maar ik weet niet hoe.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    //10
    {
      id: "other_choices",
      type: "choice",

      ...base_choice_style,

      fixedImageBackground: baseBackgroundImg,

      fixedImageBackgroundStyle: {
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        zIndex: 0,
      },

      contentStyle: {
        width: "100%",
        maxWidth: "500px",
        marginLeft: "auto",
        marginRight: "auto",
        color: "white",
        zIndex: 100,
      },

      contentTextStyle: {
        textTransform: "none",
        textAlign: "center",
      },
      contentText:
        'Wil je weten wat er zou gebeurd zijn mocht je <span class="background-underlined large white">andere keuzes</span> hebben gemaakt?',

      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Ja, ik ga terug naar het begin van het parcours",
          buttonStyle: otherChoiceButtonStyle,
          action: "goNext",
          nextStepId: "SIFA 01",
        },
        {
          type: "button",
          key: "button-2",
          text: "Nee",
          buttonStyle: otherChoiceButtonStyle,
          action: "goNext",
          nextStepId: "-1",
        },
      ],
    },
    {
      id: "mapBukavu",
      type: "map",
      background: baseBackgroundImg,
      mapImage: mapBukavu,
      mapContainerClass: "cursor-gray",
      nextStepDelay: 3500,
      nextStepId: "SIFA 07",
    },
    {
      id: "SIFA 07",
      type: "sequence",
      sound: SIFA_FR_SEQ07,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Bukavu is een grote stad aan de grens met Rwanda. ", delay: 3050 },
        { type: "text", text: "Gelukkig hebben we de stad zonder problemen bereikt", delay: 3060 },
        { type: "text", text: "en hebben we onze familie gevonden\u2026 en onze moeder. ", delay: 2970 },
        { type: "text", text: "Ze is een paar weken voor ons aangekomen.", delay: 3110 },
        { type: "text", text: "Ik ben zo blij. ", delay: 2920 },
        { type: "text", text: "Maar ik weet ook dat het niet goed gaat met haar\u2026", delay: 1130 },
        { type: "text", text: "Ze slaapt slecht, ze eet niet veel.", delay: 3810 },
        { type: "text", text: "Ik weet dat ze verkracht is en zwanger is.", delay: 2990 },
        { type: "text", text: "Ik weet niet hoe ze zich voelt, \nik durf er niet met haar over te praten.", delay: 2960 },
        { type: "text", text: "Mijn familie is lief, maar ze waren niet echt blij met onze komst.", delay: 4010 },
        { type: "text", text: "voor hen betekent dat nog eens drie mensen erbij om te voeden.", delay: 4130 },
        { type: "text", text: "Maar we kunnen niet terug naar Mbau.", delay: 4030 },
        { type: "text", text: "", delay: 3890 },
        { type: "goToNext", delay: 2090 },
      ],
      background: {
        src: sifaBG7,
        style: { animationFillMode: "forwards", animationTimingFunction: "linear" },
        animations: [{ delay: 50, style: { animationName: "scale20", animationDuration: "44150ms" } }],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 08",
    },
    {
      id: "SIFA 08",
      type: "sequence",
      sound: SIFA_FR_SEQ08,
      sound_delay: 50,
      sequence: [
        {
          type: "text",
          text: "Mijn familie wil ons niet op straat zetten, maar het zou veel gemakkelijker \nzijn voor hen als we weg zouden gaan. ",
          delay: 2170,
        },
        { type: "text", text: "Maar naar waar ?", delay: 7040 },
        { type: "text", text: "Sommige Congolezen gaan naar Oeganda, maar welke toekomst hebben ze daar ?", delay: 1980 },
        { type: "text", text: "Ik hoor veel over Oeganda. ", delay: 4890 },
        { type: "text", text: "Volgens sommigen geeft de regering land aan vluchtelingen \nen mogen we dat bewerken.", delay: 1980 },
        { type: "text", text: "Anderen zeggen dan weer dat er niets is. ", delay: 4970 },
        { type: "text", text: "Alleen maar vluchtelingenkampen waar we allemaal op elkaar gepakt zitten. ", delay: 2120 },
        { type: "text", text: "Zal ik mijn familie ervan proberen te overtuigen ", delay: 4890 },
        { type: "text", text: "dat we zelf in ons onderhoud zullen voorzien en gaan werken? ", delay: 2110 },
        { type: "text", text: "Dan kunnen we in Bukavu blijven, \ntenminste tot mijn moeder bevallen is.", delay: 3910 },
        { type: "text", text: "", delay: 4990 },
        { type: "goToNext", delay: 1960 },
      ],
      background: {
        src: sifaBG8,
        style: { width: "120vw", position: "relative", left: "-20vw" }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "43010ms", animationName: "translateX0To20vw" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "info4",
    },
    {
      id: "choice4",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Ik weet niet welke beslissing de juiste is. Wat zou jij in deze situatie doen?<br/>Zou je met je <span class="background-underlined large">familie praten</span> en hen ervan overtuigen jou bij hen te laten blijven? Of zou je naar <span class="background-underlined very-large">Oeganda proberen gaa</span>n?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Praten met je familie",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "SIFA 09",
        },
        {
          type: "button",
          key: "button-2",
          text: "Plannen maken om naar Oeganda te gaan",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "mapKampala",
        },
      ],
    },
    //15
    {
      id: "SIFA 09",
      type: "sequence",
      sound: SIFA_FR_SEQ09,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Mijn familie laat ons blijven op voorwaarde \ndat we helpen met de huur en het eten. ", delay: 4220 },
        { type: "text", text: "We werken allemaal: ", delay: 5020 },
        { type: "text", text: "mijn broertjes helpen de marktkramers en ik maak schoon in een kapsalon. ", delay: 1880 },
        { type: "text", text: "Mijn moeder is bevallen van mijn zusje.", delay: 4910 },
        { type: "text", text: "", delay: 3080 },
        { type: "goToNext", delay: 2070 },
      ],
      background: {
        src: sifaBG9,
        style: { width: "120vw", position: "relative", left: "-20vw" }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "21180ms", animationName: "translateX0To20vw" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 10",
    },
    {
      id: "SIFA 10",
      type: "sequence",
      sound: SIFA_FR_SEQ10,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Nu mijn moeder bevallen is, \npraten we over wat we nu gaan doen.", delay: 2110 },
        { type: "text", text: "Als we genoeg werken, \nkunnen we een huis in Bukavu betalen.", delay: 4090 },
        { type: "text", text: "Ik heb over een dokter gehoord terwijl ik hier woonde, ", delay: 4010 },
        { type: "text", text: "meneer Mukwege, die verkrachte vrouwen \u2018herstelt\u2019.", delay: 3010 },
        { type: "text", text: "Ik zou graag met mama naar hem gaan. ", delay: 4010 },
        { type: "text", text: "Maar mijn broertjes praten over Oeganda: daar is geen oorlog. ", delay: 2900 },
        { type: "text", text: "Ze willen graag studeren en dat kan niet als ze werken.", delay: 3970 },
        { type: "text", text: "Om naar Oeganda te gaan moeten we geld lenen van onze familie. ", delay: 3910 },
        { type: "text", text: "Maar dat zou betekenen dat we bij hen in de schuld staan.", delay: 3110 },
        { type: "text", text: "Een ander idee is dat we proberen met eigen middelen de grens over te komen.", delay: 3950 },
        { type: "text", text: "", delay: 5160 },
        { type: "goToNext", delay: 2900 },
      ],
      background: {
        src: sifaBG10,
        style: {
          // '--imageWidth': '120vw',
          // '--scale': 'calc(5/6)',
          // '--imageHeight': 'calc(120vw * 0.67)',
          // width: 'var(--imageWidth)',
          // height: 'var(--imageHeight)',
          // transformOrigin: 'top left',
          // transform: 'scale(var(--scale)) translateX(-20vw) translateY(calc( -1/2*var(--scale)*var(--imageHeight) + 50vh ) )',
          // transform: 'scale(1)',
          transformOrigin: "0 center",
          // transition: 'transform linear',
          // width:"100vw",
        },
        animations: [{ delay: 50, style: { animationDuration: "43130ms", animationName: "scale20" } }],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "info bukavu ou ouganda",
    },
    {
      id: "choice bukavu ou ouganda",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Dit is echt een heel <span class="background-underlined medium">moeilijke besl</span>issing... Wat zou jij doen?<br/>Zou je in <span class="background-underlined large">Bukavu blijven</span>, zou je met eigen middel<span class="background-underlined medium">en de grens</span> met Oeganda proberen over te steken of zou j<span class="background-underlined medium">e geld lenen</span> van je familie?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "In Bukavu blijven",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title:
              'Weet j<span class="background-underlined medium">e dat zeker</span>?<br/>Hier zijn we niet veilig voor het geweld en het leven zal niet al<span class="background-underlined medium">tijd gemakkelijk</span> zijn.',
            buttons: [
              {
                text: "Ja ik ben zeker<br/>van mijn beslissing",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "epilogue bukavu",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
        {
          type: "button",
          key: "button-2",
          text: "Zonder geld naar Oeganda gaan",
          buttonStyle: choiceButtonStyle,
          // action: 'fakeChoice',
          // actionText:
          //   'Mama wilde geen schulden hebben bij mijn familie. Ze heeft mijn broers en mij gezegd dat we langs de weg moeten gaan staan en aan boord van een vrachtwagen moeten klimmen die naar het oosten rijdt. Dat hebben we een paar dagen geprobeerd, maar niemand wilde ons meenemen.',
          // actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: '60vh', width: '40vw', maxWidth: '500px' },
          action: "showConfirmation",
          confirmationContent: {
            title:
              'Weet j<span class="background-underlined medium">e dat zeker</span>?<br/>Het zal niet eenvoudig om de grens over te steken <span class="background-underlined large">zonder geld</span>.',
            buttons: [
              {
                text: "Ja ik ben zeker<br/>van mijn beslissing",
                buttonStyle: choiceButtonStyle,
                buttonKey: "button-2",
                action: "fakeChoice",
                actionText:
                  "Mama wilde geen schulden hebben bij mijn familie. Ze heeft mijn broers en mij gezegd dat we langs de weg moeten gaan staan en aan boord van een vrachtwagen moeten klimmen die naar het oosten rijdt. Dat hebben we een paar dagen geprobeerd, maar niemand wilde ons meenemen.",
                actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: "60vh", width: "40vw", maxWidth: "500px" },
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
        {
          type: "button",
          key: "button-3",
          text: "Geld lenen",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title:
              'Weet j<span class="background-underlined medium">e dat zeker</span>?<br/>Dat wil zeggen dat je schulden hebt bij je familie. Hoe zal je hen <span class="background-underlined medium">terugbetalen</span>?',
            buttons: [
              {
                text: "Ja ik ben zeker<br/>van mijn beslissing",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "mapKampala",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
      ],
    },
    {
      id: "epilogue bukavu",

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEBukavu,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe mijn leven eruitziet in Bukavu",
          text: "We hebben ervoor gekozen in Bukavu te blijven, dat was de gemakkelijkste oplossing. Ondanks alles wat ze heeft meegemaakt, wilde mama echt niet weg uit het land waar ze is geboren. Ik ben met haar meegegaan naar het ziekenhuis van dokter Mukwege, ik hoop dat het nu beter met haar gaat. Mijn twee broertjes gaan naar school en ik zorg voor mijn kleine zusje. Jammer genoeg is er nog altijd geen nieuws over mijn vader. <br/><br/>Ik heb beter werk gevonden, ik werk nu in een bar. Ik ben trots op wat ik doe voor mijn familie. Ik hoop dat we nog vele jaren in veiligheid en vrede in Bukavu mogen leven.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    {
      id: "mapKampala",
      type: "map",
      background: baseBackgroundImg,
      mapImage: mapKampala,
      mapContainerClass: "cursor-gray",
      nextStepDelay: 3500,
      nextStepId: "SIFA 11",
    },
    //20
    {
      id: "SIFA 11",
      type: "sequence",

      sound: SIFA_FR_SEQ11,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Met het geld dat we van mijn familie hebben geleend, ", delay: 3080 },
        { type: "text", text: "zijn mijn broers en ik met de bus naar Rwanda vertrokken. ", delay: 2990 },
        { type: "text", text: "Daar zijn we een paar dagen gebleven,", delay: 3130 },
        { type: "text", text: " tot we vervoer konden regelen naar de grens met Oeganda \nen van daar het land in konden. ", delay: 2840 },
        { type: "text", text: "Na een paar dagen bereikten we een vluchtelingenkamp.", delay: 5100 },
        { type: "text", text: "Er zijn massa\u2019s mensen, we kregen een zeil om een tent te maken. ", delay: 3040 },
        { type: "text", text: "Er is weinig te eten en we kunnen geen groenten kweken of kippen houden.", delay: 5030 },
        { type: "text", text: "", delay: 5820 },
        { type: "goToNext", delay: 1170 },
      ],
      background: {
        src: sifaBG11,
        style: { transform: "scale(1.2)", transition: "transform linear" }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "32200ms", animationName: "scaleDown20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 12",
    },
    {
      id: "SIFA 12",
      type: "sequence",
      sound: SIFA_FR_SEQ12,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik weet niet meer zeker of het wel zo\u2019n goed idee was om naar hier te komen. ", delay: 2030 },
        { type: "text", text: "Mama is nog altijd in Bukavu.", delay: 4010 },
        { type: "text", text: "ze vraagt hoe het gaat en of we wat geld kunnen sturen voor haar en de baby.", delay: 2010 },
        { type: "text", text: "Ik heb niet de indruk dat er hier in het kamp veel geld te verdienen valt.", delay: 4980 },
        { type: "text", text: "Misschien kunnen we in Kampala, de hoofdstad van Oeganda, gaan werken. ", delay: 3200 },
        { type: "text", text: "Maar mijn twee broers willen hier blijven, want er is een gratis school. ", delay: 4010 },
        { type: "text", text: "En bovendien wordt er over \u2018hervestiging\u2019 gesproken. ", delay: 3940 },
        { type: "text", text: "Dat wil zeggen naar een land ver weg van de DRC gaan en nooit meer terugkomen. ", delay: 4010 },
        { type: "text", text: "Mijn broertjes zijn het allemaal moe.", delay: 4810 },
        {
          type: "text",
          text: "Ze dromen van een \u2018hervestiging\u2019, bijvoorbeeld de Verenigde Staten, \nwaar iedereen een gemakkelijk leven leidt. ",
          delay: 2060,
        },
        { type: "text", text: "Maar ik weet het nog niet goed... ", delay: 6070 },
        { type: "text", text: "", delay: 3960 },
        { type: "goToNext", delay: 2070 },
      ],
      background: {
        src: sifaBG12,
        style: { transform: "scale(1.2)", transformOrigin: "100% center" }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "47160ms", animationName: "scaleDown20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "info kampala",
    },
    {
      id: "choice kampala",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Ik w<span class="background-underlined medium">eet niet wat</span> ik moet doen. Wat zou jij in mijn plaats doen?<br/>Zou jij in je eentje <span class="background-underlined large">naar Kampala gaan</span> om te werken? Zou je je <span class="background-underlined very-large">broertjes meenemen</span>? Of zou je in het <span class="background-underlined large">vluchtelingenkamp blijven</span>?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Alleen naar Kampala gaan",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "epilogue kampala solo",
        },
        {
          type: "button",
          key: "button-2",
          text: "Samen naar Kampala gaan",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "epilogue kampala groupe",
        },
        {
          type: "button",
          key: "button-3",
          text: "Allemaal in het kamp blijven",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "SIFA 13",
        },
      ],
    },
    {
      id: "epilogue kampala solo",

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEKamaplaSolo,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe mijn leven eruitziet in Kampala",
          text: "Ik ben alleen naar Kampala gegaan, ik wilde mijn broertjes niet verplichten om mee te gaan. Ik kende er niemand en ik hing rond bij de straatkinderen. Via andere meisjes leerde ik Wilson kennen: volgens hen kon hij me helpen. Ik ben nu al enkele jaren prostituee. Ik schaam me zo, maar ik kan tenminste geld sturen naar mijn broertjes en mijn moeder. Ik vertel hen nooit hoe ik aan het geld kom … Ik heb vaak honger, ik word geslagen, ik voel me verschrikkelijk ellendig. Ik mis mijn familie en mijn leven van vroeger. Als ik maar weer gewoon normaal zou kunnen leven.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    {
      id: "epilogue kampala groupe",

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEKamaplaGroupe,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe ons leven eruitziet in Kampala",
          text: "Er was geen toekomst in het kamp. Mijn broertjes en ik hebben dan maar beslist om naar Kampala te gaan. Ik heb werk gevonden: ik kook in een straatrestaurant. Mijn broertjes werken ook en we delen een kamertje met een ander gezin. Het leven is niet gemakkelijk, maar er is tenminste geen oorlog, we zijn samen en gezond. Ik hoop dat mijn moeder, die met mijn zusje nog steeds in Bukavu woont, gauw naar ons toekomt. Jammer genoeg hebben we nog steeds geen nieuws over mijn vader.<br/><br/>Ik krijg stilaan Oegandese vrienden en leer ook wat Congolezen kennen die hun land zijn ontvlucht. Ik voel me hier steeds meer thuis. Ik denk dat we nog lang in Oeganda zullen blijven.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    //25
    {
      id: "SIFA 13",
      type: "sequence",
      sound: SIFA_FR_SEQ13,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik ben 19 jaar. ", delay: 2210 },
        { type: "text", text: "Ik zit al 6 jaren in het kamp.", delay: 1890 },
        { type: "text", text: "Een paar jaar geleden zijn mama en mijn kleine zusje naar ons toegekomen.", delay: 2080 },
        { type: "text", text: "Mijn zusje kent geen ander leven dan dat in een kamp.", delay: 4870 },
        { type: "text", text: "Het leven is hier grauw, soms werk ik een beetje,", delay: 3070 },
        { type: "text", text: "soms ga ik naar school om Engels te leren, ", delay: 3060 },
        { type: "text", text: "maar ik heb de indruk dat het nergens toe doet.", delay: 2820 },
        { type: "text", text: "We denken er vaak aan om naar Mbau terug te keren, ", delay: 2160 },
        { type: "text", text: "maar het is nog steeds gevaarlijk in de regio.", delay: 3840 },
        { type: "text", text: "Onlangs is de toestand in het kamp verslechterd.", delay: 3120 },
        { type: "text", text: "De rantsoenen zijn nog kleiner,", delay: 3060 },
        { type: "text", text: "de mensen vechten, er wordt gestolen en verkracht.", delay: 2820 },
        { type: "text", text: "ik voel me niet veilig. Ik ben het kamp zo beu.", delay: 4010 },
        { type: "text", text: "Sommige families zitten hier al 20 jaar.", delay: 3990 },
        { type: "text", text: "Is dit ons lot?", delay: 3040 },
        { type: "text", text: "", delay: 1970 },
        { type: "goToNext", delay: 50 },
      ],
      background: {
        src: sifaBG13,
        style: { transformOrigin: "center 0%" }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "48060ms", animationName: "scale20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 14",
    },
    {
      id: "SIFA 14",
      type: "sequence",
      sound: SIFA_FR_SEQ14,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Op een dag hoorden we dat we ergens anders hervestigd zouden worden,", delay: 3130 },
        { type: "text", text: "dat we binnenkort naar Belgi\u00eb zouden gaan.", delay: 3970 },
        { type: "text", text: "Eerst geloofde ik het niet. ", delay: 2910 },
        { type: "text", text: "Mijn broertjes waren heel enthousiast, \nmaar mijn moeder was verdrietig en twijfelde. ", delay: 1190 },
        { type: "text", text: "Ze had altijd gehoopt dat we weer naar huis zouden kunnen gaan, naar Mbau. ", delay: 5800 },
        { type: "text", text: "", delay: 5070 },
        { type: "goToNext", delay: 3130 },
      ],
      background: {
        src: sifaBG14,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "25200ms", animationName: "scale10" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 15",
    },
    {
      id: "SIFA 15",
      type: "sequence",
      sound: SIFA_FR_SEQ15,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Uiteindelijk zijn we dan naar Belgi\u00eb gegaan.", delay: 2160 },
        { type: "text", text: "Hier is het niet zo eenvoudig als ik had gedacht.", delay: 2950 },
        { type: "text", text: "Ik ga met mijn moeder mee om alle stappen te doorlopen.", delay: 2900 },
        { type: "text", text: "Na de opvang bij Fedasil werden we in een tijdelijke woning ondergebracht.", delay: 3130 },
        { type: "text", text: "De Belgen blijven maar herhalen dat we een woning moeten vinden, \ndat is de prioriteit.", delay: 5010 },
        { type: "text", text: "", delay: 5990 },
        { type: "goToNext", delay: 3100 },
      ],
      background: {
        src: sifaBG15,
        style: { transform: "scale(1.2)" }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "25240ms", animationName: "scaleDown20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "SIFA 16",
    },
    {
      id: "SIFA 16",
      type: "sequence",
      sound: SIFA_FR_SEQ16,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Vandaag ben ik 1 jaar in Belgi\u00eb. Ik ben 20. ", delay: 6040 },
        { type: "text", text: "Wat ga ik doen?", delay: 4090 },
        {
          type: "text",
          text: "Eerst wilde ik gaan werken om een woning te kunnen huren \nen de schuld aan mijn familie terug te betalen, ",
          delay: 1100,
        },
        { type: "text", text: "maar de sociaal assistent heeft gezegd dat ik ook voltijds naar school kan. ", delay: 5920 },
        { type: "text", text: "Ik heb nog nooit gestudeerd, is dit mijn kans? ", delay: 5000 },
        { type: "text", text: "Ik ben nooit veel naar school geweest, \nik ben bang dat ik de lessen niet zal kunnen volgen\u2026", delay: 3920 },
        { type: "text", text: "", delay: 6950 },
        { type: "goToNext", delay: 3090 },
      ],
      background: {
        src: sifaBG16,
        style: { animationFillMode: "forwards", animationTimingFunction: "linear" },
        animations: [{ delay: 50, style: { animationName: "scale20", animationDuration: "36110ms" } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: "black", transition: "opacity linear" },
        animations: [{ delay: 29110, style: { animationName: "opacityNoneToFull", animationDuration: "7000ms" } }],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: "info final",
    },
    {
      id: "choice final",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Ik weet niet wat ik moet beslissen. Wat z<span class="background-underlined medium">ou jij do</span>en?<br/>Zou je <span class="background-underlined medium">werk zoeken</span>, zou je volt<span class="background-underlined large">ijds naar school</span> gaan of zou je proberen <span class="background-underlined very-large">studeren en na schooltijd</span> gaan werken?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Voltijds gaan werken",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "epilogue fin 1",
        },
        {
          type: "button",
          key: "button-2",
          text: "Studeren en werken na schooltijd",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "epilogue fin 3",
        },
        {
          type: "button",
          key: "button-3",
          text: "Voltijds naar school gaan",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "epilogue fin 2",
        },
      ],
    },
    //30
    {
      id: "epilogue fin 1",

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEFIN1,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe ons leven eruitziet in België",
          text: "Ik heb ervoor gekozen zo veel mogelijk te gaan werken. Ik ben nooit echt naar school geweest, ik dacht dat het te laat was voor mij. Het was niet gemakkelijk om werk te vinden, want ik heb geen diploma. Ik maak ’s avonds kantoren schoon. Ik ben trots en blij dat mijn twee broers studeren en heel wat dingen leren. <br/><br/>Vandaag heeft één van mijn boers me verteld dat er in smartphones en computers mineralen van bij ons zitten. Daar was het dus voor, al die doden in mijn dorp? Ongelofelijk! Hier heeft iedereen een smartphone en een computer. Weten de mensen dat wel?!<br/><br/>In Kivu houdt het geweld aan en wij hebben nog steeds geen nieuws over mijn vader. Ik denk aan alle mensen die daar nog zitten en aan iedereen in de kampen in Oeganda. Ik heb geluk in vergelijking met hen.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    {
      id: "epilogue fin 2",

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEFIN2,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe ons leven eruitziet in België",
          text: "Ik heb beslist om mijn kans te grijpen en naar school te gaan … Ik ben veel ouder dan de andere leerlingen en ik durf niet te vaak met hen te praten. Ik heb gehoord dat ze lachen met mijn ‘rare’ Nederlands. Dus ik heb niet echt vrienden ... Mijn broers gaan ook naar school, we hebben eigenlijk geen geld en we wonen in een sociale woning. Ik voel me schuldig, want we moeten ook nog geld terugbetalen aan onze familie in Bukavu.<br/><br/>Vandaag heeft een van mijn boers me verteld dat er in smartphones en computers mineralen van bij ons zitten. Daar was het dus voor, al die doden in mijn dorp? Ongelofelijk! Hier heeft iedereen een smartphone en een computer. Weten de mensen dat wel?!<br/><br/>In Kivu houdt het geweld aan en wij hebben nog steeds geen nieuws over mijn vader. Ik denk aan alle mensen die daar nog zitten en aan iedereen in de kampen in Oeganda. Ik heb geluk in vergelijking met hen.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    {
      id: "epilogue fin 3",

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEFIN3,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe ons leven eruitziet in België",
          text: "Ik heb beslist om mijn kans te grijpen en naar school te gaan … Ik ben veel ouder dan de andere leerlingen en ik durf niet te vaak met hen te praten. Ik heb gehoord dat ze lachen met mijn ‘rare’ Nederlands. Dus ik heb niet echt vrienden ... De leerkrachten zeggen dat ik naar de huiswerkklas moet om mijn schoolresultaten te verbeteren, maar ik heb gewoon geen tijd: ’s avonds werk ik, ik maak kantoren schoon. Het is moeilijk om de twee te combineren, maar ik help tenminste mee om de schulden die we hebben bij onze familie in Bukavu terug te betalen. <br/><br/>Vandaag heeft een van mijn boers me verteld dat er in smartphones en computers mineralen van bij ons zitten. Daar was het dus voor, al die doden in mijn dorp? Ongelofelijk! Hier heeft iedereen een smartphone en een computer. Weten de mensen dat wel?!<br/><br/>In Kivu houdt het geweld aan en wij hebben nog steeds geen nieuws over mijn vader. Ik denk aan alle mensen die daar nog zitten en aan iedereen in de kampen in Oeganda. Ik heb geluk in vergelijking met hen. ",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    {
      ...base_choice_style,
      id: "info1",
      type: "info",

      contentText:
        'Wat zou jij doen in mijn plaats?<br/>Zou jij aan je ouders voorstellen om <span class="background-underlined very-large">jou in de mijn te laten</span> werken of zou je je <span class="background-underlined large">broertje laten ga</span>an?',
      actionText: "Ik informeer me eerst om Sifa te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-read-1",
          text: "Ik lees een artikel over de aanwezigheid van vrouwen in de Congolese mijnen",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title: "« Les Mamans Twangeuses », vrouwen van de mijn<br/><span class='subtitle'>Justice et Paix (samenvatting)</span>",
            text: "<span class='inline-title'>ONMISBARE VROUWEN</span>In tegenstelling tot wat men zou denken, zijn vrouwen zeer aanwezig in en rond mijnbouwgebieden. In Congo is bijna de helft van de meer dan twee miljoen mensen die in de artisanale mijnbouw werkt vrouw. Zij spelen een belangrijke rol daar, maar wel een die erg verschilt van die van mannen. Velen zijn ook het slachtoffer van discriminatie. Hoewel elke volwassene met de Congolese nationaliteit en een vergunning het recht heeft om aan ambachtelijke mijnbouw te doen, zijn er niet zoveel vrouwen met zo'n vergunning. Sommigen graven, maar de typische taken voor vrouwen daar zijn het breken, wassen, zeven, sorteren en verwerken van de mineralen. Er zijn verschillende redenen voor deze taakverdeling. Zo zouden vrouwen zogezegd minder sterk zijn. Sommigen geloven ook dat het voor vrouwen onmogelijk is om productief te zijn als zij hun menstruatie hebben. De taken van vrouwen worden minder goed betaald, zelfs wanneer zij dezelfde functies uitoefenen als mannen. Tenslotte zijn vrouwen vaak betrokken bij de handel in goederen en diensten die zich rond de mijnen ontwikkelt: eten koken, beheer van bars, restaurants, winkels en hotels. Zij krijgen vaak te maken met agressieve klanten die niet kunnen of willen betalen. <span class='inline-title'>GEWELD</span>Afgezien van deze sociaal-economische aspecten, hebben mijnen een aanzienlijke invloed op het leven en het lichaam van vrouwen. En hoewel het onderwerp taboe blijft, is seksueel geweld geen uitzondering. Volgens een studie van de Wereldbank wordt 40% van de vrouwen die in de artisanale mijnbouw in het oosten van Congo werkt, op een gegeven moment seksueel misbruikt of komt ze in de prostitutie terecht. Dit soort geweld is niet alleen te wijten aan rebellengroeperingen of strijdgroepen daar aanwezig. Ook gewone burgers maken zich hier schuldig aan. Naast seksueel geweld worden sommige vrouwen dagelijks het slachtoffer van bruut geweld en chantage door mannen, zonder dat zij er zelfs maar aan kunnen denken een beroep te doen op de veiligheidsdiensten of de plaatselijke autoriteiten, die vaak ver weg zijn of niet geïnteresseerd zijn in hun lot. De meeste vrouwen voelen zich dus niet veilig in de mijnen.<br/><br/>Dit is een samenvatting van een artikel van Justice et Paix <a href='https://www.justicepaix.be/femmes-dans-les-mines-comment-extraire-l-egalite/' target='blank'>“Femmes dans les mines, comment extraire l’égalité?”</a> gepubliceerd op 6 maart 2020",
          },
        },
        {
          type: "button",
          key: "button-read-2",
          text: "Ik lees een artikel over kinderarbeid in Congo",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title: "Kinderbescherming, een uitdaging in Congo<br/><span class='subtitle'>Justice et Paix (samenvatting)</span>",
            text: "<span class='inline-title'>KINDEREN AAN HET WERK</span>Volgens een rapport dat UNICEF en de Internationale Arbeidsorganisatie (IAO) in juni 2021 publiceerden, worden wereldwijd 160 miljoen kinderen gedwongen te werken. Sub-Sahara Afrika is de regio in de wereld met het meeste kinderarbeid: 1 op de 5 kinderen wordt er gedwongen om te werken.<span class='inline-title'>WAAROM KINDERARBEID?</span>In 2021 was 60% van de bevolking van Congo jonger dan 18 jaar. Slechts de helft van de kinderen tussen 6 en 11 jaar gaat echter naar de lagere school. Veel kinderen leven nog steeds op straat. Door een gebrek aan toegankelijk onderwijs en steun van de overheid is de financiële situatie voor vele gezinnen erg onzeker. Kinderen, zowel meisjes als jongens, vallen ten prooi aan moderne slavernij. Hun ouders sturen hen naar de mijnen wat vaak de enige manier is om te overleven. De kinderen worden ingezet als hulpje voor de mijnwerkers en serveren hen maaltijden, moeten materiaal schoonmaken of dragen zware zandzakken.  Deze kinderen worden zo blootgesteld aan de chemische stoffen die voor de ontginning worden gebruikt. Deze stoffen zijn erg schadelijk en veroorzaken ziektes. <br/><br/>Door het conflict in Oost-Congo worden kinderen soms ook op jonge leeftijd onder dwang door gewapende groepen gerekruteerd om te werken. Omdat ze zo klein zijn, is het makkelijker voor hen om binnen te kruipen in de smalste ondergrondse gangen die ontoegankelijk zijn voor volwassenen. Kinderen lopen hier enorm gevaar omdat zij nog niet zo goed de risico's van instorting en verstikking kunnen inschatten.<br/><br/>In de Congolese grondwet van 18 februari 2006 werd geprobeerd het kind een centrale plaats te geven. De bescherming van het kind werd een prioriteit. Het benadrukt de verplichting van de staat om kinderen te beschermen \"tegen elke aantasting van hun gezondheid, hun opvoeding en hun geestelijke ontwikkeling\". Deze speciale wet ter bescherming van het kind werd aangenomen na veel druk van verschillende organisaties. Ondanks deze inspanningen worden nog steeds veel kinderen uitgebuit in de mijnen.<br/><br/>Dit is een samenvatting van het artikel van Justice et Paix: <a href='https://www.justicepaix.be/lutilisation-denfants-dans-lexploitation-des-ressources-minieres-a-lest-de-la-rd-congo-entre-urgence-et-perspective/' target='_blank'>“L’utilisation d’enfants dans l’exploitation des ressources minières à l’est de la RD Congo: entre urgence et perspective”</a> gepubliceerd op 25 juni 2021",
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice1",
    },
    {
      ...base_choice_style,
      id: "info2",
      type: "info",

      contentText:
        'Ik weet niet wat ik moet doen... Wat zou jij doen?<br/>Zou je in de <span class="background-underlined large">buurt van het dorp</span> blijven om je familie te zoeken of zou je jezelf in <span class="background-underlined large">veiligheid brengen</span> en weglopen?',
      actionText: "Ik informeer me eerst om Sifa te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-read-1",
          text: "Ik lees een artikel over de moeilijke en onzekere situatie in Oost-Congo",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title: "Een moeilijke realiteit voor de bevolking<br/><span class='subtitle'>Justice et Paix (samenvatting)</span>",
            text: 'De veiligheidssituatie in het oosten van Congo is alarmerend en geweld ligt er continu op de loer. Schendingen van de mensenrechten, zoals etnische moordpartijen, ontvoeringen, plunderingen en het ronselen van kinderen bij gewapende groepen zijn alomtegenwoordig. Human Rights Watch schrijft deze schendingen tegenover de burgerbevolking toe aan zowel gewapende groepen (FDLR, ADF, NDC-R, Maï-Maï Yakatumba bijvoorbeeld) als aan leden van het reguliere leger (FARDC). Volgens een door de ngo uitgevoerde barometer werden in 2018 alleen al in de provincies Noord- en Zuid-Kivu 883 burgers gedood en 1.400 burgers ontvoerd.<br/><br/>De chaos in de regio zorgt voor moeilijke levensomstandigheden voor de bevolking. Zij zijn de eerste slachtoffers van de anarchistische en intensieve exploitatie van de grondstoffen. Geweld, invallen van gewapende groepen in dorpen (met plunderingen en massaal seksueel geweld) dwingen de bevolking regelmatig hun huizen te ontvluchten. Het sociale weefsel wordt vernietigd en dit brengt het vreedzame samenleven met de verschillende bevolkingsgroepen ernstig in gevaar. Hierdoor wordt het nog moeilijker om stabiliteit en vrede te bekomen.<br/><br/>Dit is een samenvatting van uittreksels uit het onderwijsdossier " Derrière nos écrans: les enjeux de l’exploitation minière. Zoom sur la République démocratique du Congo”, gepubliceerd door Justice et Paix  in 2019.',
          },
        },
        {
          type: "button",
          key: "button-read-2",
          text: "Ik lees een artikel over de gewapende groepen die aanwezig zijn in Oost-Congo",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title: "Meer dan 100 gewapende groeperingen actief in het oosten van Congo",
            text: "De afgelopen twintig jaar waren er vele gewapende groepen in de oostelijke provincies van Congo (Noord- en Zuid-Kivu, maar ook Ituri en Maniema). Er wordt geschat dat er tussen de 100 en 150 van dergelijke groepen zijn, waarvan ongeveer de helft daadwerkelijk actief is. De trend die sinds het begin van de jaren 2010 wordt waargenomen, is er een van fragmentatie: er zijn duidelijk steeds meer kleine gewapende groepen.<br/><br/>Er zijn groepen uit de buurlanden (Oeganda, Rwanda of Burundi) maar ook Congolese groepen. Op sommige plaatsen hebben dorpen \"zelfverdedigingsgroepen\" opgericht, de Mai-Mai, die beweren te strijden tegen gewelddadige indringers bijvoorbeeld. In werkelijkheid plegen deze groepen vaak dezelfde misdaden als anderen en buiten zij de plaatselijke bevolking uit<br/><br/>Groot of klein, lokaal of uit het buitenland, wat deze gewapende groepen gemeen hebben en wat vaak zelfs een reden van hun aanwezigheid is, is het doel om zoveel mogelijk te profiteren van de rijkdommen die onder de grond zitten. Soms rechtstreeks, soms door de bevolking uit te buiten.<br/><br/>Deze groepen handelen internationaal in mineralen om zichzelf te verrijken, wapens te kopen en de macht over de regio te behouden. Hun methodes verschillen soms: sommige graven zelf naar mineralen; andere dwingen mannen, vrouwen en kinderen voor hen te werken; nog andere houden de gravers onder gijzeling op de mijn zelf of leggen wegversperringen op. In alle gevallen leggen deze groepen hun wil op met geweld. Hoewel de Congolese regering tracht grip te krijgen op de zaak door samen te werken met de regeringen van de buurlanden om de gewapende bendes een halt toe te roepen, bemoeilijken talrijke factoren (geografie, gebrek aan wegen, de vele betrokken actoren...) dit. De gewapende groepen blijven hierdoor vaak ongestraft verder doen. <br/><br/>Dit fictief artikel is geïnspireerd op een reportage van DW <a href='https://www.dw.com/fr/une-centaine-de-groupes-arm%C3%A9s-actifs-dans-lest-de-la-rdc/a-51664664' target='_blank'>“Une centaine de groupes armés actifs dans l’est de la RDC”</a> gepubliceerd op 13 december 2019",
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice2",
    },
    //35
    {
      ...base_choice_style,
      id: "info3",
      type: "info",

      contentText:
        "Wat een <span class='background-underlined large'>moeilijke keuze</span>! Wat zou jij doen in mijn plaats?<br/>Zou jij de gewapende mannen vertrouwen en <span class='background-underlined large'>bij de bende gaan</span>? Of zou je naar Bukavu proberen te gaan, op zoek naar <span class='background-underlined medium'>je familie</span>, ook al is dit een reis met veel risico’s ?",
      actionText: "Ik informeer me eerst om Sifa te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-read-1",
          text: "Ik lees een rapport over de redenen waarom kinderen zich aansluiten bij de gewapende groepen ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title:
              "« Kinderen sluiten zich aan bij gewapende groepen om hun families, etnische groepen en gemeenschappen te beschermen. »<br/><span class='subtitle'>Stuurgroep inzake kinderen en gewapende conflicten in de DRC, MONUSCO (samenvatting)</span>",
            text: 'Het rekruteren van kinderen wordt meestal als illegaal beschouwd maar 50 landen staan het nog steeds toe. Daar waar het verboden is wordt de wet vaak met de voeten getreden. <br/><br/>Hoewel de rekrutering door de “forces armées de la République démocratique du Congo » (FARDC) de afgelopen 10 jaar is afgenomen, neemt het aantal kinderen dat door gewapende groepen en milities wordt gerekruteerd weer toe. Dit vooral sinds de start van het conflict in de Kasai-regio eind 2016.  Er zijn geen precieze cijfers over kinderen die zich (al dan niet gedwongen) bij gewapende groepen in Oost-Congo hebben aangesloten. Verschillende algemene schattingen wijzen er op dat een groot aantal kinderen betrokken is bij gewapende conflicten. Sinds 2000 heeft MONUSCO de betrokkenheid van meer dan 31.000 kinderen bij gewapende groepen in het land gedocumenteerd. Gewapende groepen en lokale milities die actief zijn in landen als  Congo, ronselen kinderen van vier of vijf jaar oud als dragers, spionnen, boodschappers of voor seksuele uitbuiting.<br/><br/>Uit de interviews blijkt dat, vooral in perioden van minder intense conflicten in Congo, vrijwel alle kinderen die zich bij een gewapende groep aansluiten dit "vrijwillig" doen en dat gedwongen rekrutering eerder de uitzondering is. De rekrutering van kinderen, zelfs indien niet gedwongen, blijkt echter vaak de enige optie te zijn. Dit door bijvoorbeeld een moeilijke situatie thuis. <span class="inline-title">REDENEN</span>Situaties waaruit kinderen ontsnappen door zich aan te sluiten bij een gewapende groep zijn bijvoorbeeld armoede, werkloosheid, honger, tribalisme (stammenstrijd), misbruik thuis, mishandeling door de politie, gewapende groepen of de wens om wraak te nemen. <span class="inline-title">AANTREKKINGSKRACHT</span>Wat het idee om zich aan te sluiten bij een gewapende groep dan weer aantrekkelijk maakt is het idee dat dit toegang geeft tot voedsel, geld, bescherming, een betere sociale status, betere levensopties en de mogelijkheid om hun familie te verdedigen en beschermen. <br/><br/>Dit is een artikel uit de <a href="https://monusco.unmissions.org/sites/default/files/newsletter3_de_lequipe_speciale_des_nations_unies_pour_les_enfants_et_les_conflits_armes_en_rdc_0.pdf" target="_blank">nieuwsbrief</a> van de speciale dienst van de Verenigde Naties voor de bescherming van kinderen in gewapende conflicten (MONUSCO) gepubliceerd in januari 2018',
          },
        },
        {
          type: "button",
          key: "button-read-2",
          text: "Ik lees de getuigenis van Mohamed, een ex-kindsoldaat",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title:
              "Mohamed, meegenomen door een gewapende groepering en kind-soldaat op zijn 9de<br/><span class='subtitle'>Speciale dienst voor kindsoldaten in conflictgebieden in Congo, MONUSCO (samenvatting)</span>",
            text: 'Mijn vader was een handelaar. Hij kocht spullen om die vervolgens te verkopen. We verhuisden naar de plek Béni waar we vredig leefden tot mijn vader stierf. Een paar dagen later vertelde mijn moeder ons dat we weer moesten verhuizen maar wou niet zeggen waarheen. Onderweg kwamen we gewapende mannen tegen. Het was de ADF Nalu. Ik was zo bang. Ze stopten ons en namen me mee. Uiteindelijk kwam ik te weten dat mijn moeder met hen samenwerkte om me bij hen te krijgen. <br/><br/>Toen we in hun kamp aankwamen, begon de gewapende groep onmiddellijk met een militaire training. Er waren ook meisjes bij ons. Sommige van de kinderen waren van mijn leeftijd. Na twee weken militaire training, werd ik aangesteld als IO (inlichtingenofficier).  Ik verzamelde informatie en werkte het oorlogsplan tegen de regering uit. Al die tijd dat ik bij de ADF Nalu was, werd ik niet betaald. Ik leefde van alles wat ik kon vinden in de wildernis, bijna 250 km van onze basis.<br/><br/>Het aantal mensen dat ik gedood heb kan ik niet meer tellen. Ik kon niets anders. Het was de enige manier om ons te beschermen tegen de vijanden. Ze vertelden ons dat de vijanden de FARDC of de bevolking waren.<br/><br/>Op een dag leidden we een aanval tegen de FARDC. Velen van ons werden gedood. Ik was gewond aan mijn hand. De FARDC droeg me over aan de agenten van de kinderbescherming die me verzorgden en me naar school lieten gaan. Ik verkies dit nieuwe leven boven dat van de gewapende groep. Ik heb veel vreselijke dingen meegemaakt die een kind niet zou moeten meemaken. Ik zou ieder kind afraden zich bij een gewapende groep aan te sluiten. We horen daar niet thuis.<br/><br/>Dit is een artikel uit de <a href="https://monusco.unmissions.org/sites/default/files/newsletter3_de_lequipe_speciale_des_nations_unies_pour_les_enfants_et_les_conflits_armes_en_rdc_0.pdf" target="_blank">nieuwsbrief</a> van de speciale dienst van de Verenigde Naties voor de bescherming van kinderen in gewapende conflicten (MONUSCO) gepubliceerd in januari 2018',
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice3",
    },
    {
      ...base_choice_style,
      id: "info4",
      type: "info",

      contentText:
        'Ik weet niet welke beslissing de juiste is. Wat zou jij in deze situatie doen?<br/>Zou je met je <span class="background-underlined large">familie praten</span> en hen ervan overtuigen jou bij hen te laten blijven? Of zou je naar <span class="background-underlined very-large">Oeganda proberen gaa</span>n?',
      actionText: "Ik informeer me eerst om Sifa te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-read-1",
          text: "Ik lees een artikel over de ‘Oegandese gastvrijheid’",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title: "Oeganda zou het meest gastvrije land ter wereld zijn",
            text: 'Oeganda staat op de 4de plaats wereldwijd als land dat het meeste vluchtelingen opvangt. In juni 2021 waren er maar liefst 1,4 miljoen vluchtelingen. Deze mensen zijn hoofdzakelijk afkomstig uit Congo, Burundi en Zuid-Soedan.<br/><br/>Er wordt dan ook gezegd dat Oeganda het meest gastvrije land ter wereld is. Hun vluchtelingenbeleid waarborgt de basisrechten van de vluchtelingen. Vluchtelingen in Oeganda mogen zich vrij verplaatsen, werken, een bedrijf opzetten, krijgen toegang tot gezondheidszorg en onderwijs voor henzelf en hun kinderen... De Oegandese staat geeft vluchtelingen ook stukken land, zodat ze een huis kunnen bouwen en aan landbouw kunnen doen. <br/><br/>De Oegandese regering verdedigt dit open beleid door te verwijzen naar de recente geschiedenis van het land. Oeganda heeft in het verleden immers veel onrust gekend. Velen zijn zelf ooit moeten vluchtelingen. Nu Oeganda een vreedzaam gebied is, wil de regering solidair zijn voor mensen in nood. De meerderheid van de Oegandese bevolking staat positief tegenover vluchtelingen: zij worden niet gezien als indringers maar wel als bron van welvaart, mensen met talenten die zich kunnen integreren in de plaatselijke economie en deze tot bloei kunnen brengen.<br/><br/>Dit fictieve artikel is geïnspireerd op de reportage van Africanews <a href="https://www.un.org/africarenewal/fr/magazine/d%C3%A9cembre-2018-mars-2019/r%C3%A9fugi%C3%A9s-l%E2%80%99hospitalit%C3%A9-ougandaise" target="_blank">“Réfugiés: l’hospitalité ougandaise”</a> gepubliceerd in december 2018.',
          },
        },
        {
          type: "button",
          key: "button-read-2",
          text: "Ik lees de getuigenis van Divine, vluchteling in een kamp in Oeganda",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title: "Het vluchtelingenkamp: veilig, maar zonder toekomst",
            text: '<span class="inline-title">Opnieuw in vrede leven</span>Divine is 20 jaar oud en komt uit de provincie Ituri in het noordoosten van Congo. Zij is zojuist in Oeganda aangekomen, op de vlucht voor het geweld in haar thuisprovincie met haar man en dochtertje per boot over het Albertmeer. <br/><br/>We kwamen in Oeganda aan op een boot met ongeveer 50 mensen," zegt Divine. Toen ons dorp was platgebrand, vluchtten we zo snel mogelijk naar het meer. De overtocht duurde lang. Toen we in een vissersdorp in Oeganda aankwamen, werden we met de bus naar een zogenaamd opvangcentrum gebracht. Toen namen we een andere bus naar een leeg veld ver weg. Daar bouwden we een schuilplaats met hout en zeilen." <br/><br/>"Toen ik in Oeganda aankwam, was ik enorm opgelucht. Hier zijn veel mensen maar blijkbaar geen geweld. Ik kan slapen zonder een oog open te houden, zonder angst om midden in de nacht op de vluchten te moeten slaan. Leven in vrede is het belangrijkste.  Congo is mijn land, maar ik zou er nooit terug naartoe willen. ik heb er mijn hele familie verloren, alleen mijn man en ik zijn nog over. We zijn van plan in Oeganda te blijven en hier ons leven op te bouwen.<span class="inline-title">EEN ONZEKER BESTAAN</span>Toch is het leven niet gemakkelijk in het kamp. Geopend begin 2018, heeft het een capaciteit van 100.000 mensen... Ondertussen zijn er al meer dan 90.000 mensen geregistreerd. Er zijn ongeveer 1.000 aankomsten per dag.<br/><br/>Met zo\'n groot aantal mensen, worden veel dingen moeilijk. Het voedsel raakt snel op, en de toegang tot water is beperkt. Aangezien Divine en haar gezin problemen hadden om zich bij aankomst te laten registreren, kregen zij niet meteen een rantsoenkaart en waren zij voor voedsel aangewezen op de vrijgevigheid van andere vluchtelingen.  Buren deelden hun rantsoen met hen. "We kunnen niets krijgen. We drinken al het water dat we kunnen vinden, hoe vuil het ook is. Als we het koken, kunnen we het drinken," zegt Divine.<br/><br/>Divine hoopt dat haar verblijf in het kamp tijdelijk is. Ze heeft het gevoel dat haar leven, dat van haar man en dat van haar kind in de wacht is gezet. "Hier zijn we niet in gevaar, maar we doen niets, we brengen de tijd door met praten met de buren. Ik zou graag een baan of opleiding krijgen, maar er is geen opleiding in het kamp. Op dit moment kan ik niets doen om mijn toekomst op te bouwen," zegt ze.<br/><br/>Dit fictief artikel is geïnspireerd op een reportage van Oxfam International <a href="https://www.oxfam.org/fr/en-ouganda-la-vie-en-suspens-des-refugies-sud-soudanais" target="_blank">“En Ouganda, la vie en suspens des réfugiés sud-soudanais"</a> gepubliceerd in 2018',
          },
        },
        {
          type: "button",
          key: "button-ask",
          text: "Ik vraag aan Sifa: “wat zegt je hart?”",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: "openDialog",
          dialogContent: {
            type: "image",
            imageSrc: PhylactereChezNous,
            imageStyle: {
              marginBottom: "15vh",
              width: "30vw",
              maxWidth: "400px",
              height: "auto",
              maxHeight: "50vh",
              objectFit: "contain",
              objectPosition: "center",
            },
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice4",
    },
    {
      ...base_choice_style,
      id: "info bukavu ou ouganda",
      type: "info",

      contentText:
        'Dit is echt een heel <span class="background-underlined medium">moeilijke besl</span>issing... Wat zou jij doen?<br/>Zou je in <span class="background-underlined large">Bukavu blijven</span>, zou je met eigen middel<span class="background-underlined medium">en de grens</span> met Oeganda proberen over te steken of zou j<span class="background-underlined medium">e geld lenen</span> van je familie?',
      actionText: "Ik informeer me eerst om Sifa te helpen de juiste beslissing te nemen:",

      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik luister naar de getuigenis van Salem die uit Oeganda is moeten vluchten.",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("_aHbwgFPOng"),
          },
        },
        {
          type: "button",
          key: "button-read-1",
          text: "Ik lees een artikel over een dokter in Bukavu",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title:
              "Interview van Denis Mukwege, Nobelprijswinnaar voor de vrede in 2018<br/><span class='subtitle'>ONU Femmes France (résumé)</span>",
            text: 'In Congo is professor Denis Mukwege, winnaar van de Nobelprijs voor de Vrede in 2018, een van de meest vooraanstaande experts ter wereld op het gebied van de behandeling van genitale verminking. Hij wordt ook wel "de man die vrouwen heelt" genoemd en vecht, ondanks de risico’s, om de stem van deze vrouwen te laten horen. Hij eist gerechtigheid en wil een einde maken aan de straffeloosheid van degenen die verantwoordelijk zijn voor de oorlogen, bloedbaden en misdaden die de recente geschiedenis van zijn land hebben getekend.<span class="inline-title">WAT IS DE PANZI STICHTING EN WAT IS HAAR MISSIE?</span>Dr. Denis Mukwege: De Panzi Stichting, opgericht op 12 juni 2008, heeft als doel vrouwen "volwaardige actoren te maken in een samenleving waar sociale cohesie heerst". Haar missie is te werken aan de volledige ontwikkeling van vrouwen door middel van psychologische, juridische en sociaal-economische zorg. Daarnaast is er natuurlijk ook de medische behandeling voor vrouwen die het slachtoffer zijn van seksueel geweld.<br/><br/>Sinds de oprichting van het Panzi Ziekenhuis in 1999 zijn er bijna 100.000 patiënten behandeld, waaronder bijna 55.000 overlevenden van seksueel geweld en meer dan 45.000 patiënten die leden aan ernstige gynaecologische aandoeningen. Dankzij onze 370 gekwalificeerde en toegewijde artsen, verpleegkundigen en ondersteunend personeel worden elk jaar bijna 18.000 consultaties uitgevoerd in het ziekenhuis en in de poliklinieken op het platteland.<span class="inline-title">WAT IS UW AANPAK VAN DE ZORG VOOR EN BEHANDELING VAN SLACHTOFFERS VAN SEKSUEEL GEWELD?</span>Dr. Denis Mukwege: Wij hebben een holistisch programma opgezet dat in staat voor de zorg van vrouwelijke slachtoffers van seksueel geweld (FVVS). Elke vrouw werkt samen met onze artsen, clinici en maatschappelijk werkers om een aangepast fysiek en psychologisch genezingsproces uit te stippelen. Als het slachtoffer daarna in staat is haar dader te identificeren, verleent de Stichting haar rechtsbijstand. Tot slot, wanneer het slachtoffer het ziekenhuis verlaat, biedt ons personeel bemiddeling en advies om haar re-integratie te vergemakkelijken. Ook wordt financiële bijstand, in de vorm van een microkrediet, verleend aan het slachtoffer om haar in staat te stellen een inkomensgenererende activiteit op te zetten. Taboes moeten worden doorbroken en slachtoffercomplexen moeten worden overwonnen om vrouwen in staat te stellen een volwaardige rol in de samenleving te laten spelen. Vrouwenemancipatie en leiderschap zijn de enige wapens om hun slachtofferschap om te zetten in overwinning, lijden in kracht en macht om hun geschonden waardigheid te herwinnen.<br/><br/>Dit is een samenvatting van een <a href="https://www.onufemmes.fr/nos-actualites/interview-du-dr-mukwege-prix-nobel-de-la-paix-2018" target="_blank">interview met Denis Mukwege</a>, door Sophie Pouget voor ONU Femmes France, gepubliceerd op 1 oktober 2020',
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice bukavu ou ouganda",
    },
    {
      ...base_choice_style,
      id: "info kampala",
      type: "info",

      contentText:
        'Ik w<span class="background-underlined medium">eet niet wat</span> ik moet doen. Wat zou jij in mijn plaats doen?<br/>Zou jij in je eentje <span class="background-underlined large">naar Kampala gaan</span> om te werken? Zou je je <span class="background-underlined very-large">broertjes meenemen</span>? Of zou je in het <span class="background-underlined large">vluchtelingenkamp blijven</span>?',
      actionText: "Ik informeer me eerst om Sifa te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-read-1",
          text: "Ik luister naar de getuigenis van Salem, die vertelt over haar leven in Oeganda",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("voLZ4Ieix0M"),
          },
        },
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik bekijk het interview met Laurens, expert bij Caritas die uitleg geeft over relocatie (hervestiging)",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            // videoIframe: getYoutubeIframe("A1FRiweZ3Lo"),
            videoIframe: getYoutubeIframe("RtDAbsAgncY"),
          },
        },
        {
          type: "button",
          key: "button-ask",
          text: "Ik vraag aan Sifa: wat zegt jouw hart?",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: "openDialog",
          dialogContent: {
            type: "image",
            imageSrc: PhylactereFrere,
            imageStyle: {
              marginBottom: "15vh",
              width: "30vw",
              maxWidth: "400px",
              height: "auto",
              maxHeight: "50vh",
              objectFit: "contain",
              objectPosition: "center",
            },
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice kampala",
    },
    {
      ...base_choice_style,
      id: "info final",
      type: "info",
      contentText:
        'Ik weet niet wat ik moet beslissen. Wat z<span class="background-underlined medium">ou jij do</span>en?<br/>Zou je <span class="background-underlined medium">werk zoeken</span>, zou je volt<span class="background-underlined large">ijds naar school</span> gaan of zou je proberen <span class="background-underlined very-large">studeren en na schooltijd</span> gaan werken?',
      actionText: "Ik informeer me eerst om Sifa te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik luister naar de getuigenis van Salem, die vertelt over haar aankomst in België",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("Rn2cU4Skp0Y"),
          },
        },
        {
          type: "button",
          key: "button-watch-2",
          text: "Ik bekijk de getuigenis van Prince, over de moeilijkheden die hij in België had",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("Oes5TCxFtyQ"),
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice final",
    },
    //40
  ],
};
